<div [ngClass]="{'open': !(isNavBarCollapsed$ | async)}" id="header-navbar-wrapper">
    <ds-themed-header></ds-themed-header>
    <ds-themed-navbar></ds-themed-navbar>
</div>
